import { baseApi } from 'core/api';

const state = () => ({
    _items: null,
    _pagination: null,
    _parameters: {
        page: 1,
        sortBy: 'created_at',
        sortOrder: 'desc',
        search: null,
        length: 10,
    },
    _editing: null,
    _deleting: null,
});

const getters = {
    clientInvitations: (state) => state._items,
    clientInvitationEditing: (state) => state._editing,
    clientInvitationDeleting: (state) => state._deleting,
    clientInvitationsParameters: (state) => state._parameters,
    clientInvitationsPagination: (state) => state._pagination,
};

const actions = {
    loadClientInvitation(id) {
        return baseApi.get(`core/agency/invites/${id}`).then((response) => {
            this._setClientInvitationLoaded(response.data);
            return response;
        });
    },

    loadClientInvitations(retry) {
        if (retry === true) {
            this._setClientInvitationsLoadRetry();
        }

        return baseApi.get('core/agency/invites', { params: this._parameters }).then((response) => {
            this._setClientInvitationsLoaded(response.data);
        });
    },

    sendClientInvite(form) {
        return form.post('core/agency/invites').then((response) => {
            this.loadClientInvitations();
            return response;
        });
    },

    updateClientInvite({ id, form }) {
        return form.post(`core/agency/invites/${id}`).then((response) => {
            this._setClientInvitationUpdated({
                id: id,
                data: response.data,
            });
            return response;
        });
    },

    revokeClientInvitation({ id, form }) {
        return form.delete(`core/agency/invites/${id}`).then((response) => {
            this.loadClientInvitations();
        });
    },

    updateAgencyInvitesByIdResend({ id }) {
        return baseApi.post(`core/agency/invites/${id}/resend`).then((response) => {
            return response.data;
        });
    },

    updateAgencyInvitesValidate(data) {
        return baseApi.post('core/agency/invites/validate', data).then((response) => {
            return response.data;
        });
    },

    setClientInvitationsUpdateSort(sort) {
        this._setClientInvitationsUpdateSort(sort);
        return this.loadClientInvitations();
    },

    setClientInvitationsUpdateSearch(search) {
        this._setClientInvitationsUpdateSearch(search);
        return this.loadClientInvitations();
    },

    setClientInvitationsClearSearch() {
        this._setClientInvitationsSearchCleared();
        return this.loadClientInvitations();
    },

    setClientInvitationsUpdatePage(page) {
        this._setClientInvitationsUpdatePage(page);
        return this.loadClientInvitations();
    },

    setClientInvitationsUpdateLength(page) {
        this._setClientInvitationsUpdateLength(page);
        return this.loadClientInvitations();
    },

    setClientInvitationEditing(clientInvitation) {
        this._setClientInvitationEditing(clientInvitation);
    },

    setClientInvitationDeleting(clientInvitation) {
        this._setClientInvitationDeleting(clientInvitation);
    },

    setClientInvitationUpdated(contact) {
        this._setClientInvitationUpdated(contact);
    },

    _setUserMeSignal() {
        this._clientInvitation = null;
    },

    _setClientInvitationLoaded(data) {
        this._clientInvitation = data;
    },

    _setClientInvitationsLoadRetry() {
        this._items = null;
    },

    _setClientInvitationsLoaded(data) {
        this._items = data.data;
        this._pagination = {
            current_page: data.current_page,
            from: data.from,
            last_page: data.last_page,
            per_page: data.per_page,
            to: data.to,
            total: data.total,
        };
    },

    _setClientInvitationUpdated({ id, data }) {
        let index = this._items.findIndex((o) => o.id === id);
        this._items.splice(index, 1, data);
    },

    _setClientInvitationsUpdateSort(data) {
        this._parameters.sortBy = data.sortBy;
        this._parameters.sortOrder = data.sortOrder;
    },

    _setClientInvitationsUpdateSearch(data) {
        this._parameters.search = data;
    },

    _setClientInvitationsUpdatePage(data) {
        this._parameters.page = data;
    },

    _setClientInvitationsUpdateLength(data) {
        this._parameters.length = data;
    },

    _setClientInvitationsSearchCleared() {
        this._parameters.search = null;
    },

    _setClientInvitationEditing(data) {
        this._deleting = null;
        this._editing = data;
    },

    _setClientInvitationDeleting(data) {
        this._deleting = data;
    },
};

export default {
    state,
    getters,
    actions,
};
